import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { OpenPositionStore } from './openPosition.types';

const useOpenPositionStoreBase = create<OpenPositionStore>()(
  devtools(
    set => ({
      // #region state
      state: {
        openPositionBestAsk: null,
        openPositionBestBid: null,
        openPositionMarkData: new Map(),
      },
      // #endregion

      // #region actions
      actions: {
        updateBestBidBestAsk: (data: { best_ask: string; best_bid: string }) => {
          set(
            store => ({
              state: {
                ...store.state,
                openPositionBestAsk: data.best_ask,
                openPositionBestBid: data.best_bid,
              },
            }),
            false,
            'updateBestBidBestAsk' // -> This is used for devtools
          );
        },
        updateOpenPositionMark: (data: {
          product_id: number;
          price: number;
          best_ask: string;
          best_bid: string;
        }) => {
          set(
            store => {
              const newMarkData = new Map(store.state.openPositionMarkData);
              newMarkData.set(data.product_id, {
                mark_price: data.price,
                best_ask: data.best_ask,
                best_bid: data.best_bid,
              });
              return {
                state: {
                  ...store.state,
                  openPositionMarkData: newMarkData,
                },
              };
            },
            false,
            'updateOpenPositionMark' // -> This is used for devtools
          );
        },
      },
      // #endregion
    }),
    {
      name: 'OpenPositionStore',
      serialize: {
        options: true,
      },
    }
  )
);

export { useOpenPositionStoreBase };
